import script from "./id.vue?vue&type=script&setup=true&lang=js"
export * from "./id.vue?vue&type=script&setup=true&lang=js"

import "./id.vue?vue&type=style&index=0&id=f55c0f8a&lang=css"

const __exports__ = script;

export default __exports__